import TlcSearchbarSection from './TlcSearchbarSection';
import TlcShortcutsSection from './TlcShortcutsSection';
import TlcOnlinePractitionersSection from './TlcOnlinePractitionersSection';
import TlcAdvantagesSection from './TlcAdvantagesSection';
import TlcHowItWorkSection from './TlcHowItWorkSection';
import TlcReimbursementSection from './TlcReimbursementSection';
import TlcWhatIsItSection from './TlcWhatIsItSection';
import TlcPharamcySection from './TlcPharamcySection';

export {
  TlcSearchbarSection,
  TlcShortcutsSection,
  TlcOnlinePractitionersSection,
  TlcAdvantagesSection,
  TlcHowItWorkSection,
  TlcReimbursementSection,
  TlcWhatIsItSection,
  TlcPharamcySection,
};
